/* ============================================
   MCHOSE — Pré-lançamento JavaScript
   ============================================ */

(function () {
  'use strict';

  /* ── Section 1: Hero scroll arrow ── */
  function initHeroScroll() {
    var arrow = document.querySelector('.mc-hero__scroll');
    if (!arrow) return;
    arrow.addEventListener('click', function () {
      var next = document.querySelector('.mc-expand');
      if (next) next.scrollIntoView({ behavior: 'smooth' });
    });
  }

  /* ── Section 2: Expand — 3 slides scroll-driven com animações SVG ── */

  /* Constrói animação 1: blocos empilhando — pirâmide invertida fine-line */
  function buildBlocksAnim(container) {
    if (!container || container.querySelector('svg')) return;
    var NS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 200 200');

    // 6 blocos empilhando de baixo pra cima, em forma de pirâmide
    // Os primeiros (mais embaixo) são maiores, os de cima menores
    var blocks = [
      // Linha 1 (base, mais larga): 3 blocos
      { x: 20,  y: 150, w: 50, h: 30 },
      { x: 75,  y: 150, w: 50, h: 30 },
      { x: 130, y: 150, w: 50, h: 30 },
      // Linha 2 (meio): 2 blocos
      { x: 50,  y: 110, w: 50, h: 30 },
      { x: 105, y: 110, w: 45, h: 30 },
      // Linha 3 (topo): 1 bloco
      { x: 75,  y: 70,  w: 50, h: 30 }
    ];

    blocks.forEach(function (b) {
      var rect = document.createElementNS(NS, 'rect');
      rect.setAttribute('x', b.x);
      rect.setAttribute('y', b.y);
      rect.setAttribute('width', b.w);
      rect.setAttribute('height', b.h);
      rect.setAttribute('class', 'mc-block');
      svg.appendChild(rect);
    });

    container.appendChild(svg);
  }

  /* Constrói animação 2: globo wireframe */
  function buildGlobeAnim(container) {
    if (!container || container.querySelector('svg')) return;

    var NS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '-110 -110 220 220');

    var R = 90;

    function project(x, y, z, rotY, rotX) {
      var cy = Math.cos(rotY), sy = Math.sin(rotY);
      var x1 = x * cy + z * sy;
      var z1 = -x * sy + z * cy;
      var cx = Math.cos(rotX), sx = Math.sin(rotX);
      var y1 = y * cx - z1 * sx;
      var z2 = y * sx + z1 * cx;
      return { x: x1, y: y1, z: z2 };
    }

    var outer = document.createElementNS(NS, 'circle');
    outer.setAttribute('r', R);
    outer.setAttribute('cx', 0);
    outer.setAttribute('cy', 0);
    outer.setAttribute('class', 'mc-globe__outer');
    svg.appendChild(outer);

    var latitudes  = [-60, -30, 0, 30, 60];
    var longitudes = [0, 30, 60, 90, 120, 150];

    var latPaths = latitudes.map(function (deg) {
      var p = document.createElementNS(NS, 'path');
      p.setAttribute('class', 'mc-globe__line');
      svg.appendChild(p);
      return { el: p, lat: (deg * Math.PI) / 180 };
    });

    var lonPaths = longitudes.map(function (deg) {
      var p = document.createElementNS(NS, 'path');
      p.setAttribute('class', 'mc-globe__line');
      svg.appendChild(p);
      return { el: p, lon: (deg * Math.PI) / 180 };
    });

    var dotsCoords = [
      { lat:  20, lon:  10 }, { lat:  35, lon:  60 }, { lat: -10, lon: 100 },
      { lat:  50, lon: 140 }, { lat: -30, lon: 200 }, { lat:  15, lon: 250 },
      { lat:  45, lon: 300 }, { lat: -25, lon: 340 }, { lat:   5, lon:  45 },
      { lat:  60, lon: 220 }, { lat: -45, lon: 120 }, { lat:  25, lon: 175 }
    ];

    var dotsData = dotsCoords.map(function (d) {
      var c = document.createElementNS(NS, 'circle');
      c.setAttribute('r', 1.4);
      c.setAttribute('class', 'mc-globe__dot');
      svg.appendChild(c);
      return { lat: (d.lat * Math.PI) / 180, lon: (d.lon * Math.PI) / 180, el: c };
    });
    dotsData[2].el.setAttribute('class', 'mc-globe__dot mc-globe__dot--pulse');

    container.appendChild(svg);

    var rotY = 0;
    var tiltX = -0.35;

    function frame() {
      rotY += 0.004;

      latPaths.forEach(function (item) {
        var lat = item.lat;
        var y = R * Math.sin(lat);
        var r = R * Math.cos(lat);
        var d = '';
        var segs = 64;
        for (var i = 0; i <= segs; i++) {
          var a = (i / segs) * Math.PI * 2;
          var x = r * Math.cos(a);
          var z = r * Math.sin(a);
          var p = project(x, y, z, rotY, tiltX);
          if (p.z < -0.5) {
            if (d.charAt(d.length - 1) === ' ') continue;
            d += ' ';
          } else {
            var cmd = (d === '' || d.charAt(d.length - 1) === ' ') ? 'M' : 'L';
            d += cmd + p.x.toFixed(2) + ' ' + p.y.toFixed(2);
          }
        }
        item.el.setAttribute('d', d);
      });

      lonPaths.forEach(function (item) {
        var lon = item.lon;
        var d = '';
        var segs = 48;
        for (var i = 0; i <= segs; i++) {
          var a = (i / segs) * Math.PI - Math.PI / 2;
          var x0 = R * Math.cos(a) * Math.cos(lon);
          var z0 = R * Math.cos(a) * Math.sin(lon);
          var y0 = R * Math.sin(a);
          var p = project(x0, y0, z0, rotY, tiltX);
          if (p.z < -0.5) {
            if (d.charAt(d.length - 1) === ' ') continue;
            d += ' ';
          } else {
            var cmd = (d === '' || d.charAt(d.length - 1) === ' ') ? 'M' : 'L';
            d += cmd + p.x.toFixed(2) + ' ' + p.y.toFixed(2);
          }
        }
        item.el.setAttribute('d', d);
      });

      dotsData.forEach(function (d) {
        var x = R * Math.cos(d.lat) * Math.cos(d.lon);
        var z = R * Math.cos(d.lat) * Math.sin(d.lon);
        var y = R * Math.sin(d.lat);
        var p = project(x, y, z, rotY, tiltX);
        if (p.z < -0.5) {
          d.el.style.opacity = '0';
        } else {
          d.el.setAttribute('cx', p.x.toFixed(2));
          d.el.setAttribute('cy', p.y.toFixed(2));
          d.el.style.opacity = String(Math.min(1, (p.z + 0.5) / 30 + 0.3));
        }
      });

      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  /* Constrói animação 3: circuito tec — anéis concêntricos + linhas + nodes */
  function buildCircuitAnim(container) {
    if (!container || container.querySelector('svg')) return;
    var NS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '-100 -100 200 200');

    // 3 anéis concêntricos com tracejado
    var ringRadii = [85, 60, 35];
    ringRadii.forEach(function (r, i) {
      var c = document.createElementNS(NS, 'circle');
      c.setAttribute('cx', 0);
      c.setAttribute('cy', 0);
      c.setAttribute('r', r);
      c.setAttribute('class', 'mc-circuit-ring');
      // Tracejado diferente em cada anel para dar visual tec
      if (i === 0) c.setAttribute('stroke-dasharray', '4 6');
      if (i === 1) c.setAttribute('stroke-dasharray', '2 4');
      // i === 2 fica sólido (substitui o stroke-dasharray do CSS)
      if (i === 2) c.style.strokeDasharray = '600';
      svg.appendChild(c);
    });

    // 4 linhas radiais conectando anéis
    var lines = [
      { x1: 0,   y1: -85,  x2: 0,   y2: -35 },
      { x1: 85,  y1: 0,    x2: 35,  y2: 0   },
      { x1: 0,   y1: 85,   x2: 0,   y2: 35  },
      { x1: -85, y1: 0,    x2: -35, y2: 0   }
    ];
    lines.forEach(function (l) {
      var line = document.createElementNS(NS, 'line');
      line.setAttribute('x1', l.x1);
      line.setAttribute('y1', l.y1);
      line.setAttribute('x2', l.x2);
      line.setAttribute('y2', l.y2);
      line.setAttribute('class', 'mc-circuit-line');
      svg.appendChild(line);
    });

    // Nodes (pontos) nos cruzamentos dos anéis externos
    var nodes = [
      { cx: 0,    cy: -85,  pulse: false },
      { cx: 60.1, cy: -60.1,pulse: false },
      { cx: 85,   cy: 0,    pulse: true  },  // node com pulso
      { cx: 60.1, cy: 60.1, pulse: false },
      { cx: 0,    cy: 85,   pulse: false },
      { cx: -60.1,cy: 60.1, pulse: false },
      { cx: -85,  cy: 0,    pulse: false },
      { cx: -60.1,cy: -60.1,pulse: false }
    ];
    nodes.forEach(function (n) {
      var dot = document.createElementNS(NS, 'circle');
      dot.setAttribute('cx', n.cx);
      dot.setAttribute('cy', n.cy);
      dot.setAttribute('r', n.pulse ? 2.4 : 1.6);
      dot.setAttribute('class', 'mc-circuit-node' + (n.pulse ? ' mc-circuit-pulse' : ''));
      svg.appendChild(dot);
    });

    // Node central (CPU) com pulso
    var center = document.createElementNS(NS, 'circle');
    center.setAttribute('cx', 0);
    center.setAttribute('cy', 0);
    center.setAttribute('r', 3);
    center.setAttribute('class', 'mc-circuit-node mc-circuit-pulse');
    svg.appendChild(center);

    container.appendChild(svg);
  }

  function initExpand() {
    var section = document.querySelector('.mc-expand');
    if (!section) return;

    var slides = section.querySelectorAll('.mc-expand__slide');
    var dots   = section.querySelectorAll('.mc-expand__dot');
    if (!slides.length) return;

    // Constrói animações de cada slide
    slides.forEach(function (slide) {
      var anim = slide.querySelector('.mc-expand__anim');
      if (!anim) return;
      var type = anim.dataset.anim;
      if (type === 'blocks')      buildBlocksAnim(anim);
      else if (type === 'globe')  buildGlobeAnim(anim);
      else if (type === 'circuit') buildCircuitAnim(anim);
    });

    var total = slides.length;
    var current = 0;
    var cycleTimer = null;
    var started = false;

    /*
     * Ciclo de cada slide:
     *   0ms     → ativa slide (animação central aparece)
     *   1500ms  → adiciona is-shifted (animação desliza esq, texto entra)
     *   4000ms  → remove is-active (fade out completo)
     *   4400ms  → próximo slide
     */
    var SHIFT_DELAY  = 1500;
    var TEXT_HOLD    = 2500;
    var FADE_OUT     = 400;

    function showSlide(idx) {
      // Remove tudo dos outros
      slides.forEach(function (s, i) {
        if (i !== idx) {
          s.classList.remove('is-active', 'is-shifted');
        }
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });

      var slide = slides[idx];
      slide.classList.add('is-active');


      // Após SHIFT_DELAY, desloca animação e mostra texto
      setTimeout(function () {
        if (slide.classList.contains('is-active')) {
          slide.classList.add('is-shifted');
        }
      }, SHIFT_DELAY);

      // Após holding completo, vai pro próximo
      cycleTimer = setTimeout(function () {
        slide.classList.remove('is-active', 'is-shifted');
        setTimeout(function () {
          current = (idx + 1) % total;
          showSlide(current);
        }, FADE_OUT);
      }, SHIFT_DELAY + TEXT_HOLD);
    }

    function start() {
      if (started) return;
      started = true;
      // Reseta classes do slide inicial (já tem is-active no HTML)
      slides[0].classList.remove('is-active', 'is-shifted');
      // Pequeno delay para garantir que o CSS aplique o estado inicial
      setTimeout(function () { showSlide(0); }, 50);
    }

    // Click nos dots: pula para o slide e reinicia ciclo
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        clearTimeout(cycleTimer);
        slides.forEach(function (s) { s.classList.remove('is-active', 'is-shifted'); });
        setTimeout(function () {
          current = i;
          showSlide(i);
        }, 50);
      });
    });

    // Inicia quando a section entra no viewport
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          start();
          io.unobserve(section);
        }
      });
    }, { threshold: 0.3 });
    io.observe(section);
  }

    /* ── Section 3: Vertical slider — desktop scroll-driven, mobile swipe horizontal ── */
  function initVSlider() {
    var section = document.querySelector('.mc-vslider');
    if (!section) return;

    var inner       = section.querySelector('.mc-vslider__inner');
    var mediaSlides = section.querySelectorAll('.mc-vslider__media .mc-vslider__slide');
    var copySlides  = section.querySelectorAll('.mc-vslider__copy .mc-vslider__slide');
    var dots        = section.querySelectorAll('.mc-vslider__dot');

    if (!mediaSlides.length || !inner) return;

    var total = mediaSlides.length;
    var current = 0;

    /* === MOBILE: monta combos imagem + texto e sincroniza scroll === */
    function buildMobileCombos() {
      // Evita duplicar
      if (inner.querySelector('.mc-vslider__combo')) return;

      for (var i = 0; i < total; i++) {
        var imgEl  = mediaSlides[i].querySelector('.mc-vslider__img');
        var copyEl = copySlides[i];
        if (!imgEl || !copyEl) continue;

        var combo = document.createElement('div');
        combo.className = 'mc-vslider__combo';
        combo.dataset.slide = i;

        var imgWrap = document.createElement('div');
        imgWrap.className = 'mc-vslider__img-wrap';
        var imgClone = imgEl.cloneNode(true);
        imgWrap.appendChild(imgClone);

        var textWrap = document.createElement('div');
        textWrap.className = 'mc-vslider__text';
        textWrap.innerHTML = copyEl.innerHTML;

        combo.appendChild(imgWrap);
        combo.appendChild(textWrap);
        inner.appendChild(combo);
      }
    }

    function setupMobileScroll() {
      var combos = inner.querySelectorAll('.mc-vslider__combo');
      if (!combos.length) return;

      function updateDotsFromScroll() {
        var scrollLeft = inner.scrollLeft;
        var slideWidth = inner.clientWidth;
        var idx = Math.round(scrollLeft / slideWidth);
        idx = Math.max(0, Math.min(total - 1, idx));
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }

      inner.addEventListener('scroll', updateDotsFromScroll, { passive: true });

      // Click nos dots scrolla até o slide
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          if (window.innerWidth > 768) return;
          inner.scrollTo({ left: i * inner.clientWidth, behavior: 'smooth' });
        });
      });
    }

    /* === DESKTOP: scroll-driven com pinned === */
    function activateDesktop(idx) {
      if (idx === current) return;
      current = idx;
      mediaSlides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      copySlides.forEach( function (s, i) { s.classList.toggle('is-active', i === idx); });
      dots.forEach(       function (d, i) { d.classList.toggle('is-active', i === idx); });
    }

    function onScrollDesktop() {
      if (window.innerWidth <= 768) return;
      var rect     = section.getBoundingClientRect();
      var totalH   = section.offsetHeight - window.innerHeight;
      var scrolled = -rect.top;
      var progress = Math.max(0, Math.min(1, scrolled / totalH));
      var idx = Math.min(total - 1, Math.floor(progress * total));
      if (idx !== current) activateDesktop(idx);
    }

    // Click dots desktop
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        if (window.innerWidth <= 768) return;
        var rect   = section.getBoundingClientRect();
        var top    = window.pageYOffset + rect.top;
        var frac   = i / (total - 1);
        var target = top + frac * (section.offsetHeight - window.innerHeight);
        window.scrollTo({ top: target, behavior: 'smooth' });
      });
    });

    window.addEventListener('scroll', onScrollDesktop, { passive: true });

    /* === Inicializa conforme tamanho de tela === */
    function init() {
      if (window.innerWidth <= 768) {
        buildMobileCombos();
        setupMobileScroll();
      } else {
        onScrollDesktop();
      }
    }

    init();

    // Reinicializa em resize
    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(init, 200);
    });
  }

  /* ── Section 4: Form ── */
  function initForm() {
    var formEl   = document.getElementById('mc-prelaunch-form');
    var formCard = document.querySelector('.mc-form');

    if (!formEl || !formCard) return;

    formEl.addEventListener('submit', function (e) {
      e.preventDefault();

      var name  = document.getElementById('mc-nome');
      var email = document.getElementById('mc-email');
      var btn   = formEl.querySelector('.mc-form__btn');

      if (!name || !email) return;

      var nameVal  = name.value.trim();
      var emailVal = email.value.trim();
      var validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal);

      if (!nameVal || !validEmail) {
        if (!nameVal)    name.style.borderColor  = 'rgba(255,80,80,0.6)';
        if (!validEmail) email.style.borderColor = 'rgba(255,80,80,0.6)';
        return;
      }

      name.style.borderColor = '';
      email.style.borderColor = '';

      var rdToken = formCard.dataset.rdToken || '';
      if (btn) { btn.textContent = 'Cadastrando...'; btn.disabled = true; }

      if (!rdToken) {
        // Sem token: apenas mostra sucesso
        formCard.classList.add('is-success');
        return;
      }

      var payload = {
        event_type: 'CONVERSION',
        event_family: 'CDP',
        payload: {
          conversion_identifier: 'pre-lancamento-mchose',
          name: nameVal,
          email: emailVal,
          cf_origem: 'landing-mchose',
          legal_bases: [{ category: 'communications', type: 'consent', status: 'granted' }]
        }
      };

      fetch('https://api.rd.services/platform/conversions?api_key=' + rdToken, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function () { formCard.classList.add('is-success'); })
        .catch(function (err) {
          console.error('RD error:', err);
          if (btn) { btn.textContent = 'CADASTRAR-SE'; btn.disabled = false; }
        });
    });

    ['mc-nome', 'mc-email'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.addEventListener('input', function () { this.style.borderColor = ''; });
    });

    // Reveal do card
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          formCard.classList.add('is-visible');
          obs.unobserve(formCard);
        }
      });
    }, { threshold: 0.2 });
    obs.observe(formCard);
  }

  /* ── Section 5: Horizontal slider — duplica para loop ── */
  function initHSlider() {
    var track = document.querySelector('.mc-hslider__track');
    if (!track) return;
    // Duplica o conteúdo para loop infinito
    track.innerHTML = track.innerHTML + track.innerHTML;
  }

  /* ── Init geral ── */
  function init() {
    initHeroScroll();
    initExpand();
    initVSlider();
    initForm();
    initHSlider();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();